<div class="dashboard dashboard-hasAside landing">
  <div class="dashboardTopBar">
    <a routerLink="." class="dashboardTopBar-logo">
      <img src="assets/images/logo.svg" alt="Tasheel Logo" />
    </a>

    <!-- top bar -->
    <div class="dashboardTopBar-content">
      <button (click)="showModal = true" type="button" class="button button-primary button-long modal-openModalButton" data-bs-target="#product-selection-popup">
        <span>{{ "DashBoard.Home.ApplyNow" | translate }}</span>
      </button>

      <a routerLink="." (click)="login()" class="dashboardTopBar-profileLink">
        <span> {{ "DashBoard.Parent.Login" | translate }}</span>
      </a>

      <span (click)="toggleLang()" style="cursor: pointer" class="dashboardMobileToolbar-navListItemLanguageSelector">
        <span class="languageSelector fw-bold" lang="ar" *ngIf="!isLeft">English</span>
        <span class="languageSelector fw-bold" lang="ar" *ngIf="isLeft">عربي</span>
      </span>
    </div>
  </div>

  <!-- side bar -->
  <div class="dashboardSideBar">
    <nav class="w-100">
      <ul class="dashboardSideBar-navList">
        <li class="active">
          <a routerLink=".">
            <svg width="22px" height="22px">
              <use xlink:href="assets/images/icons.svg#home"></use>
            </svg>
            <span>{{ "DashBoard.Parent.Dashboard" | translate }}</span>
          </a>
        </li>
        <li>
          <a href="{{ 'Landing.Navigation.Offers.Url' | translate }}" target="_blank">
            <svg width="22px" height="22px">
              <use xlink:href="assets/images/icons.svg#offer"></use>
            </svg>
            <span>
              {{ "DashBoard.Parent.Offers" | translate }}
            </span>
          </a>
        </li>

        <li>
          <a href="{{ 'Landing.Navigation.Calculator' | translate }}" target="_blank">
            <svg width="24px" height="24px">
              <use xlink:href="assets/images/settings-calc.svg"></use>
            </svg>
            <span>{{ "DashBoard.Parent.Calculator" | translate }}</span>
          </a>
        </li>

        <li>
          <a href="{{ 'Landing.Navigation.FAQs.Url' | translate }}" target="_blank">
            <svg width="22px" height="22px">
              <use xlink:href="assets/images/icons.svg#circle-question"></use>
            </svg>
            <span> {{ "DashBoard.Parent.FAQs" | translate }}</span>
          </a>
        </li>
        <li>
          <a href="{{ 'Landing.Navigation.Help.Url' | translate }}" target="_blank">
            <svg width="22px" height="22px">
              <use xlink:href="assets/images/icons.svg#phone"></use>
            </svg>
            <span>{{ "DashBoard.Parent.Help" | translate }}</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>

  <!-- mobile bottom bar and menu -->
  <div class="dashboardMobileToolbar" [class.dashboardMobileToolbar-nav-open]="showMenu">
    <!-- mobile bottom bar -->
    <nav class="dashboardMobileToolbar-mainNav">
      <ul class="dashboardMobileToolbar-mainNavList">
        <li [class.active]="activeChild == 'home'" (click)="activeChild = 'home';showModal = false">
          <a routerLink=".">
            <svg width="22px" height="22px">
              <use xlink:href="assets/images/icons.svg#home"></use>
            </svg>
            {{ "DashBoard.Parent.Dashboard" | translate }}
          </a>
        </li>

        <li>
          <a href="{{ 'Landing.Navigation.Help.Url' | translate }}" target="_blank">
            <svg width="22px" height="22px">
              <use xlink:href="assets/images/icons.svg#phone"></use>
            </svg>
            {{ "DashBoard.Parent.Help" | translate }}
          </a>
        </li>

        <li class="dashboardMobileToolbar-mainNavListItemCta">
          <button type="button" class="button button-primary modal-openModalButton"
            data-bs-target="#product-selection-popup" (click)="showModal = true">
            <span>{{ "DashBoard.Home.ApplyNow" | translate }}</span>
          </button>
        </li>
        <li>
          <a href="{{ 'Landing.Navigation.Offers.Url' | translate }}" target="_blank">
            <svg width="22px" height="22px">
              <use xlink:href="assets/images/icons.svg#offer"></use>
            </svg>
            {{ "DashBoard.Parent.Offers" | translate }}
          </a>
        </li>
        <li class="dashboardMobileToolbar-mainNavListListItemToggle">
          <button (click)="showMenu = true" class="dashboardMobileToolbar-mainNavListToggleListButton" type="button">
            <svg width="22px" height="22px">
              <use xlink:href="assets/images/icons.svg#burger-menu"></use>
            </svg>
            {{ "DashBoard.Parent.Menu" | translate }}
          </button>
        </li>
      </ul>
    </nav>
    <!-- mobile menu -->
    <nav class="dashboardMobileToolbar-nav">
      <div class="dashboardMobileToolbar-navHeading">
        <a routerLink="." class="dashboardMobileToolbar-logo">
          <img src="assets/images/TasheelLogoEnglish.svg" alt="Tasheel Logo" />
        </a>
        <button (click)="showMenu = false" type="button" class="dashboardMobileToolbar-navCloseButton">
          <svg width="18px" height="18px">
            <use xlink:href="assets/images/icons.svg#x"></use>
          </svg>
          <span class="visually-hidden">
            {{ "DashBoard.Home.Close" | translate }}
          </span>
        </button>
      </div>
      <div class="dashboardMobileToolbar-navBody">
        <ul class="dashboardMobileToolbar-navList">
          <li>
            <svg width="22px" height="22px">
              <use xlink:href="assets/images/icons.svg#sparkle"></use>
            </svg>
            <a routerLink=".">{{ "DashBoard.Parent.Partners" | translate }} &amp;
              {{ "DashBoard.Parent.Promotions" | translate }}</a>
          </li>
          <li>
            <svg width="24px" height="24px">
              <use xlink:href="assets/images/settings-calc.svg"></use>
            </svg>
            <a href="{{ 'Landing.Navigation.Calculator' | translate }}" target="_blank">
              <span>{{ "DashBoard.Parent.Calculator" | translate }}</span>
            </a>
          </li>
          <li>
            <svg width="22px" height="22px">
              <use xlink:href="assets/images/icons.svg#circle-question"></use>
            </svg>
            <a routerLink=".">FAQs</a>
          </li>
          <li (click)="login()" style="cursor: pointer">
            <svg width="22px" height="22px">
              <use xlink:href="assets/images/icons.svg#exit"></use>
            </svg>
            <a routerLink=".">
              {{ "DashBoard.Parent.Login" | translate }}
            </a>
          </li>
          <li (click)="toggleLang()" style="cursor: pointer" class="dashboardMobileToolbar-navListItemLanguageSelector">
            <img width="22px" src="assets/images/globe.svg" />
            <span class="languageSelector" lang="ar" *ngIf="!isLeft">English</span>
            <span class="languageSelector" lang="ar" *ngIf="isLeft">عربي</span>
          </li>
        </ul>
      </div>
    </nav>
  </div>

  <!-- Welcome header -->
  <header style="padding-inline-end: 0">
    <div class="container-fluid">
      <div class="dashboardHeader">
        <h1>{{ "DashBoard.Home.WelcomeToTasheel" | translate }}</h1>
        <button type="button" class="snb-referral-card" (click)="goToReferenceSignIn()">
          <div class="snb-referral-card-logoWrapper">
            <img [src]="snbLogoPath" alt="SNB logo" class="snb-referral-card-logo" />
          </div>
          <div class="snb-referral-card-content">
            <strong>{{ isLeft ? "SNB Referral" : "إحالة SNB" }}</strong>
            <span>{{ isLeft ? 'Enter your referral code' : 'الدخول برقم إحالة البنك الأهلي' }}</span>
          </div>
          <span class="snb-referral-card-action">
            {{ isLeft ? "Proceed":"متابعة" }}
          </span>
        </button>
      </div>
    </div>
  </header>

  <!-- Product marketing cards -->
  <main>
    <section>
      <div class="container-fluid">
        <app-horizontal-scroller class="horizontal-cards centered" [rowScroller]="true">
          <!--Personal Finance-->
          <product-marketing-card product="PersonalFinance" (applyClicked)="apply($event)"></product-marketing-card>
          <!--Baseeta-->
          <product-marketing-card product="Baseeta"></product-marketing-card>
          <!--Credit Card-->
          <product-marketing-card product="CreditCard" (applyClicked)="apply($event)"></product-marketing-card>
          <!--Installment Sales-->
          <!-- <product-marketing-card product="InstallmentSales" (applyClicked)="apply($event)"></product-marketing-card> -->
        </app-horizontal-scroller>
        <div class="vertical-cards">
          <!--Personal Finance-->
          <product-marketing-card product="PersonalFinance" (applyClicked)="apply($event)"></product-marketing-card>
          <!--Baseeta-->
          <product-marketing-card product="Baseeta" (reverse)="true"></product-marketing-card>
          <!--Credit Card-->
          <product-marketing-card product="CreditCard" (applyClicked)="apply($event)"></product-marketing-card>
          <!--Installment Sales-->
          <!-- <product-marketing-card product="InstallmentSales" (applyClicked)="apply($event)"></product-marketing-card> -->
        </div>
      </div>
    </section>
  </main>
</div>

<!-- Product selection popup  -->
<div id="product-selection-popup" class="modal" [class.modal-show]="showModal">
  <div (click)="showModal = false" class="modal-overlay">&nbsp;</div>
  <div class="modal-panel">
    <button (click)="showModal = false" class="modal-closeButton" type="button">
      <svg width="24px" height="24px">
        <use xlink:href="assets/images/icons.svg#x-thick"></use>
      </svg>
      <span class="visually-hidden">Close Modal</span>
    </button>
    <div class="modal-container">
      <div class="modal-body" style="overflow: visible">
        <div class="modal-content mt-4 align-items-center" style="border: none">
          <p class="colored text-center">
            <strong>{{ "DashBoard.Parent.ChooseTheService" | translate }}</strong>
          </p>
          <div class="boxWithHands my-4">
            <img src="assets/images/boxWithHands.svg" />
          </div>
          <p style="color: #5c677d; font-size: 14px; text-align: center">
            <strong>{{ "DashBoard.Parent.ListOfProducts" | translate }}</strong>
          </p>
          <div class="product-options mt-3 w-100 d-flex align-items-start justify-content-center">
            <div (click)="productId = 2; apply(2)" class="product-option" [class.selected]="productId == 2">
              <button>
                <img src="assets/images/Illustrations/{{ 'Illustrations.PersonalFinance' | translate }}"/>
              </button>
              <strong>{{ "DashBoard.Home.PersonalFinance" | translate }}</strong>
            </div>
            <div (click)="productId = 4; apply(4)" class="product-option" [class.selected]="productId == 4">
              <button>
                <img src="assets/images/Illustrations/{{ 'Illustrations.CreditCard' | translate }}"/>
              </button>
              <strong>{{ "DashBoard.Home.CreditCard" | translate }}</strong>
            </div>
            <div (click)="productId = 8; downloadApp()" [class.no-pointer-class]="!isMobile" [class.selected]="productId == 8" class="product-option" >
              <button class="baseeta-container">
                  <div class="baseeta-image-container">
                    <img class="baseeta-image" src="assets/images/Illustrations/{{ 'Illustrations.Baseeta' | translate }}"/>
                  </div>
                  <div  class="baseetaQR-container">
                    <img class="downloadBaseeta-QR" [src]="baseetaAppQRCode"/> 
                    <p class="downloadBaseeta-text text-gray fs-10 m-0">{{('DashBoard.Home.ScanToDownload' | translate)}}</p>
                  </div>
              </button>
              <strong>{{ "DashBoard.Home.Baseeta" | translate }} </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>